import Helpers from '../helpers/util';

class VanillaLightbox {
	constructor(el) {
		this.clsVisible = 'is-visible';
		this.el = el;
		this.children = this.el.querySelector('.lightbox-container > div');
		this.closeButton = this.el.querySelector('.js-lightbox-close');
		this.cta = this.el.querySelector('.js-external-link');
		this.attachEvents();
	}

	attachEvents = () => {
		this.closeButton.addEventListener('click', () => {
			this.hideHandler();
		});
		this.cta.addEventListener('click', () => {
			this.hideHandler();
		});
	};

	showHandler(event) {
		const { target } = event;
		const lightboxType = target.dataset.lightbox;

		if (lightboxType === 'leavesite') {
			const externalURL = target.getAttribute('href');
			if (externalURL) {
				const cta = this.el.querySelector(`.js-lightbox-${lightboxType} .js-external-link`);
				cta.setAttribute('href', externalURL);
			}
		}

		if (this.el.classList.contains(this.clsVisible)) {
			this.el.querySelector('div.is-visible').classList.remove(this.clsVisible);
		}

		if (lightboxType) {
			this.el.classList.add(this.clsVisible);
			this.el.querySelector(`.js-lightbox-${lightboxType}`).classList.add(this.clsVisible);
		}
		
		if (window.vaxihub) {
			const eventName = 'custom.event.travel_map--lightbox_open'; // Created inside GTM
			const eventObject = Helpers.GTM.create(eventName);
			Helpers.GTM.push(eventObject);
		}

	}

	hideHandler() {
		this.el.classList.remove(this.clsVisible);
		this.children.classList.remove(this.clsVisible);
		
		if (window.vaxihub) {
			const eventName = 'custom.event.travel_map--lightbox_close'; // Created inside GTM
			const eventObject = Helpers.GTM.create(eventName);
			Helpers.GTM.push(eventObject);
		}
	}
}

const el = document.querySelector('.js-lightbox');
let lightbox = null;

if (el) {
	lightbox = new VanillaLightbox(el);
	document.querySelector('html').addEventListener('click', event => {
		if (event.target.matches('[data-lightbox]')) {
			event.preventDefault();
			lightbox.showHandler(event);
		}
	});
}

export default lightbox;
